import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const DEFAULT_TITLE = 'Gesturely — Your trackpad, programmable.'
const DEFAULT_DESCRIPTION =
  'Turn multi-finger swipes, taps, firm presses, and drawn shapes into actions on your Mac.'

const ROUTE_METADATA: Record<string, { title: string; description: string }> = {
  '/': {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  '/buy': {
    title: 'Buy Gesturely — $14.99, once.',
    description:
      'Buy Gesturely once for $14.99 USD. No subscription, with a license for up to two personal Macs.',
  },
  '/privacy': {
    title: 'Privacy Policy — Gesturely',
    description:
      'How Maison Barkat LLC handles information when you use Gesturely, visit the website, make a purchase, or contact support.',
  },
  '/terms': {
    title: 'Terms of Use — Gesturely',
    description:
      'Terms governing the Gesturely trial, purchase, personal license, acceptable use, and support.',
  },
  '/refunds': {
    title: 'Refund Policy — Gesturely',
    description:
      'Gesturely refund terms, including the 14-day full-feature pre-purchase trial and eligible refund considerations.',
  },
}

function setMeta(selector: string, attribute: 'content', value: string) {
  const element = document.querySelector<HTMLMetaElement>(selector)
  if (element) element.setAttribute(attribute, value)
}

export function RouteMetadata() {
  const { pathname } = useLocation()

  useEffect(() => {
    const metadata = ROUTE_METADATA[pathname] ?? {
      title: 'Page not found — Gesturely',
      description: DEFAULT_DESCRIPTION,
    }

    document.title = metadata.title
    setMeta('meta[name="description"]', 'content', metadata.description)
    setMeta('meta[property="og:title"]', 'content', metadata.title)
    setMeta('meta[property="og:description"]', 'content', metadata.description)
    setMeta('meta[name="twitter:title"]', 'content', metadata.title)
    setMeta('meta[name="twitter:description"]', 'content', metadata.description)
  }, [pathname])

  return null
}
